import Commons from '../../../Services/Common/Common';

/** GetTraCustom02R1 (문서관리 SAT_BASIC_02와 동일 파라미터) */
export const M_PEA_EDU_LOG_DETAIL_Schema = {
  mapper: {
    getTraCustom02R1: {
      /** 로그인 userInfo 또는 상단에서 고른 사업장(searchInfo) */
      CustCd: (ctx) =>
        Commons.EncryptAES(
          String(ctx.userInfo?.custCd || ctx.search?.custCd || '')
        ),
      /** API 필수 — GetPeaBasicR1(search1)과 동일 */
      UserId: (ctx) => ctx.userInfo?.userid,
      StartDt: (ctx) => Commons.EncryptAES(ctx.startDtPlain ?? ''),
      EndDt: (ctx) => Commons.EncryptAES(ctx.endDtPlain ?? ''),
      SearchText: () => Commons.EncryptAES(''),
    },
    /**
     * SaveTraCustom02ApproverSign — 서버에서 AES 복호화
     * 저장 순서: UpdateMid(MID_SIGN_ID=복호화 UserId) → 전원 완료 시 MID_SIGN_YN
     * 미적중 시 UpdateFinal: FINAL_SIGN_ID=SignerId(동일), FINAL_SIGN_PATH=@SignPath 등
     */
    saveTraCustom02ApproverSign1: {
      TpmId: (ctx) => Commons.EncryptAES(String(ctx.tpmId ?? '')),
      SignPath: (ctx) => Commons.EncryptAES(String(ctx.signPath ?? '')),
      UserId: (ctx) => ctx.userInfo?.userid,
    },
    /** SaveTraCustom02ApproverReject — TpmId·ReturnDetail·UserId AES (JWT 없을 때 UserId 폴백) */
    saveTraCustom02ApproverReject1: {
      TpmId: (ctx) => Commons.EncryptAES(String(ctx.tpmId ?? '')),
      ReturnDetail: (ctx) =>
        Commons.EncryptAES(String(ctx.returnDetailPlain ?? '')),
      UserId: (ctx) => ctx.userInfo?.userid,
    },
  },
};
